import React, { useEffect, useState } from "react";

const Loader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a 15-second loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 15000);

    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, []);

  const handleRefreshClick = () => {
    window.location.reload(); // Refresh the page
  };

  useEffect(() => {
    // Apply keyframe animation styles when component mounts
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = stylesWithAnimation;
    document.head.appendChild(styleSheet);
  }, []);

  return (
    <div style={styles.container}>
      {isLoading ? (
        <div style={styles.loaderWrapper}>
          <div style={styles.loader}>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <p>Loading...</p>
        </div>
      ) : (
        <div style={styles.refreshWrapper}>
          <p>Content loaded. You can refresh if needed.</p>
          <button onClick={handleRefreshClick} style={styles.refreshButton}>
            Refresh Page
          </button>
        </div>
      )}
    </div>
  );
};

// Basic styles for loader and refresh button
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    fontFamily: "Arial, sans-serif",
  },
  loaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  loader: {
    display: "flex",
    gap: "8px",
    marginBottom: "10px",
  },
  refreshWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  refreshButton: {
    padding: "10px 20px",
    backgroundColor: "#3498db",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "20px",
  },
};

// Keyframe animation for dot pulse loader
const stylesWithAnimation = `
  .dot {
    width: 16px;
    height: 16px;
    background-color: #3498db;
    border-radius: 50%;
    display: inline-block;
    animation: pulse 1.2s infinite ease-in-out both;
  }
  .dot:nth-child(1) {
    animation-delay: -0.24s;
  }
  .dot:nth-child(2) {
    animation-delay: -0.12s;
  }
  .dot:nth-child(3) {
    animation-delay: 0;
  }

  @keyframes pulse {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
      transform: scale(1);
    }
  }
`;

export default Loader;
